import React from 'react';
import PropTypes from 'prop-types';
import { map, contains, ifElse, always, append, reject, equals, is } from 'ramda';

import Checkbox from 'material-ui/Checkbox';

import { edit, view, checkbox } from './CheckboxGroup.less';

const Edit = ({ input, meta, optionFormatter, localeMessage, options }) => (
  <div className={edit}>
    {map((option, index) => (
      <div key={option.value} className={checkbox}>
        <Checkbox
          label={option.label || localeMessage(optionFormatter ? optionFormatter(option.value) : option.value)}
          checked={contains(option.value, input.value)}
          onCheck={(e, isChecked) =>
            input.onChange(ifElse(always(isChecked), append(option.value), reject(equals(option.value)))(input.value))
          }
        />
      </div>
    ))(options)}
  </div>
);

const View = ({ input, meta, optionFormatter, localeMessage, options }) => (
  <div className={view}>
    {is(Array, input.value) &&
      map(val => (optionFormatter ? localeMessage(optionFormatter(val)) : localeMessage(val)))(input.value).join(', ')}
  </div>
);

const CheckboxGroup = ({ editing, ...other }) => (editing ? <Edit {...other} /> : <View {...other} />);

Edit.propTypes = View.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  localeMessage: PropTypes.func, // Takes a localization id and returns the message
  optionFormatter: PropTypes.func, // Takes the localization id and manipulates it, usable for namespacing
  options: PropTypes.array,
};

CheckboxGroup.propTypes = {
  editing: PropTypes.bool,
};

export default CheckboxGroup;
